import { Button, Card, Icon, Space, Typography } from '@sravni/react-design-system';
import { ArrowRight, Tip } from '@sravni/react-icons';
import { useState } from 'react';

import { useAppSelector } from 'shared/lib';

import { IconHelper } from 'features/PostIssuanceHelp/config';
import { selectPostIssuanceHelp } from 'features/PostIssuanceHelp/model';
import { EarlyRepaymentPopup } from 'features/PostIssuanceHelp/ui/EarlyRepaymentPopup';
import { OfferDocumentsInfoPopup } from 'features/PostIssuanceHelp/ui/OfferDocumentsInfoPopup';

import styles from './PostIssuanceHelp.module.scss';

export const PostIssuanceHelp = () => {
  const { helps, isAvailableEarlyRepaymentPopup, isAvailableOfferDocumentsInfoPopup } =
    useAppSelector(selectPostIssuanceHelp);
  const [visiblePopups, setVisiblePopup] = useState({
    earlyRepayment: false,
    documents: false,
  });

  const changePopupVisibility = (popupType: keyof typeof visiblePopups) =>
    setVisiblePopup((prev) => ({ ...prev, [popupType]: !prev[popupType] }));

  return (
    <Card
      className={styles.card}
      size={24}
    >
      <Space
        size={24}
        direction="vertical"
      >
        {helps?.map((item) => {
          const IconComponent = IconHelper[item.type] || Tip;

          return (
            <Space
              align="center"
              size={12}
              key={item.type}
            >
              <Space
                align="center"
                size={12}
              >
                <Space
                  justify="center"
                  align="center"
                  className={styles.icon}
                >
                  <Icon
                    size={24}
                    icon={<IconComponent />}
                  />
                </Space>

                <Space
                  size={2}
                  direction="vertical"
                >
                  <Typography.Text
                    strong
                    size={16}
                  >
                    {item.title}
                  </Typography.Text>
                  <Typography.Text
                    className="h-color-D60"
                    size={12}
                  >
                    {item.subtitle}
                  </Typography.Text>
                </Space>
              </Space>

              <Button
                className={styles.button}
                onClick={() => changePopupVisibility(item.type)}
                size={44}
                variant="text"
              >
                <Icon icon={<ArrowRight className="h-color-D30" />} />
              </Button>
            </Space>
          );
        })}
      </Space>

      {isAvailableEarlyRepaymentPopup ? (
        <EarlyRepaymentPopup
          visible={visiblePopups.earlyRepayment}
          onClose={() => setVisiblePopup((prev) => ({ ...prev, earlyRepayment: false }))}
        />
      ) : null}

      {isAvailableOfferDocumentsInfoPopup ? (
        <OfferDocumentsInfoPopup
          visible={visiblePopups.documents}
          onClose={() => setVisiblePopup((prev) => ({ ...prev, documents: false }))}
        />
      ) : null}
    </Card>
  );
};
